import { render, staticRenderFns } from "./VerificationModalStep.vue?vue&type=template&id=2f19d771&scoped=true&"
import script from "./VerificationModalStep.vue?vue&type=script&lang=js&"
export * from "./VerificationModalStep.vue?vue&type=script&lang=js&"
import style0 from "./VerificationModalStep.vue?vue&type=style&index=0&id=2f19d771&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f19d771",
  null
  
)

export default component.exports